import { Component, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import { OptionsAsideService } from "../../services/options-aside.service";
import { OptionsService } from "../../services/options.service";
import { CurrentUserService } from "../../services/current-user.service";
import { QuoteInfoService } from "../../services/quote-info.service";
import { BrowserWidthService } from "../../services/browser-width.service";

import { Option } from "../../model/option";
import { SelectedOption } from "../../model/selected-option";

@Component({
    selector: 'options-aside',
    template: require('./options-aside.component.html'),
    styles: [require('./options-aside.component.scss')]
})
export class OptionsAsideComponent implements OnDestroy {
    currentPricingView: number;

    private _savedItem: any = {};
    private tempModel: any = {};

    informationModel: any;
    //incrementQuantityOption: Option;
    options: Option[];
    selectedoptions: SelectedOption[];
    incrementQuantityOption: SelectedOption;

    showCancelEdit: boolean = false;
    resetClicked: boolean = false;
    enableSave: boolean = true;
    validQuantity: boolean = true;
    underMaxQuantity: boolean = true;
    showIncludeExcludeModal: boolean = false;
    validUnitPrice: boolean = true;
    isCustomOption: boolean;
    facilityUser: boolean = true;
    faciltiyUserWithoutApprover: boolean = false;
    facilityUserWithApprover: boolean = false;
    subscription: Subscription = new Subscription();
    isInitializing: boolean = false;
    showIncludeExcludeMessage: boolean = false;

    constructor(
        public optionsAsideService: OptionsAsideService,
        public optionsService: OptionsService,
        public currentUserService: CurrentUserService,
        public quoteInfoService: QuoteInfoService,
        public browserWidthService: BrowserWidthService
    ) {
        this.isInitializing = true;
        const informationModelSub = this.optionsAsideService.informationModel
            .subscribe(x => {
                this.informationModel = x;
                Object.assign(this._savedItem, x);
                Object.assign(this.tempModel, x);
                this.isInitializing = true;
                if (this.informationModel !== null) {
                    this.validateQuantity(false);
                    this.validateUnitPriceInitial();
                }
                this.isInitializing = false;
            });
        this.subscription.add(informationModelSub);
        const optionsSub = this.optionsAsideService.options
            .subscribe(x => {
                this.options = x;
            });
        this.subscription.add(optionsSub);

        const selectedoptionsSub = this.optionsAsideService.selectedoptions
            .subscribe(x => {
                this.selectedoptions = x;
            });
        this.subscription.add(selectedoptionsSub);


        const optionTypeSub = this.optionsAsideService.optionType.subscribe(x => this.isCustomOption = x === 'custom');
        this.subscription.add(optionTypeSub);
        const currentUserSub = this.currentUserService.currentUser$.subscribe(cu => {
            if (cu.isPlantUser) {
                if (cu.roles.includes('MyCustomHomes_Quote_Approver')) {
                    this.facilityUser = false;
                    this.faciltiyUserWithoutApprover = false;
                    this.facilityUserWithApprover = true;
                } else {
                    this.facilityUser = false;
                    this.faciltiyUserWithoutApprover = true;
                    this.facilityUserWithApprover = false;
                }
            } else {
                this.facilityUser = true;
                this.faciltiyUserWithoutApprover = false;
                this.facilityUserWithApprover = false;
            }
        });
        this.subscription.add(currentUserSub);

        const currentPricingViewSub = this.quoteInfoService.currentPricingView$.subscribe(x => {
            this.currentPricingView = x;
        });
        this.subscription.add(currentPricingViewSub);
    }

    cancelEdit() {
        if (this.checkForChanges) {
            this.showCancelEdit = true;
            this.browserWidthService.modalActive$.next(true);
        } else {
            this.optionsAsideService.closeInformationAside();
            this.showCancelEdit = false;
            this.browserWidthService.modalActive$.next(false);
        }
    }

    get checkForChanges(): boolean {
        if (this._savedItem !== undefined && this._savedItem !== null) {
            if (this.informationModel.Note !== this._savedItem.Note) {
                return true;
            }
            if (this.informationModel.Quantity !== this._savedItem.Quantity) {
                return true;
            }
            if (this.tempModel.UIUnitPrice !== this._savedItem.UIUnitPrice) {
                return true;
            }
            if (this.informationModel.AdjustedTotalPrice !== this._savedItem.AdjustedTotalPrice) {
                return true;
            }
        }
        return false;
    }

    validateQuantity(showModal: boolean) {
        this.optionsService.optionsChanged$.next(this.isInitializing ? this.optionsService.optionsChanged$.value : true);
        this.informationModel.WasChanged = this.isInitializing ? this.informationModel.WasChanged : true;
        this.informationModel.WasUIChanged = this.isInitializing ? this.informationModel.WasUIChanged : true;
        this.optionsService.markOptionChangedByFacility(this.informationModel);
        this.enableSave = false;
        this.underMaxQuantity = !this.isCustomOption ? this.disableMaxQuantity(this.informationModel) : true;
        this.showIncludeExcludeMessage = false;
        if (!this.isInitializing) {
            if (this.informationModel.IncludeExclude && this.informationModel.IncludeExclude.length > 0) {
                this.showIncludeExcludeMessage = true;
                if (this.informationModel.MaxQuantity === 0) {
                    if (this.informationModel.Quantity > 1) {
                        this.informationModel.Quantity = 1;
                    }
                } else {
                    if (this.informationModel.Quantity > this.informationModel.MaxQuantity) {
                        this.informationModel.Quantity = this.informationModel.MaxQuantity;
                    }
                }
            }
        }

        if (Number(this.informationModel.UIUnitPrice) >= 0) {

            this.validQuantity = (!(isNaN(Number(this.informationModel.Quantity)))
                && (this.informationModel.Quantity >= 0) && (this.informationModel.Quantity <= 9999))
                ? true : false;

        } else {
            this.validQuantity = this.informationModel.Quantity <= 1 ? true : false;
        }
        this.informationModel.AdjustedTotalPrice = (Number(this.informationModel.UIUnitPrice) * this.informationModel.Quantity);
        // check if unselected option and if so set error
        this.informationModel.InvalidSubOption = false;
        if (this.informationModel.SubOptionCount > 0 && this.informationModel.SelectedSubOptionId <= 0 && this.informationModel.Quantity > 0) {
            this.informationModel.InvalidSubOption = true;
        }
        this.enableSave = (this.validQuantity && this.validUnitPrice) ? true : false;
    }

    validateUnitPriceInitial() {
        this.enableSave = false;
        this.optionsService.optionsChanged$.next(this.isInitializing ? this.optionsService.optionsChanged$.value : true);

        this.validUnitPrice = ((Number(this.informationModel.UIUnitPrice) >= -99999.99) && (Number(this.informationModel.UIUnitPrice) <= 99999.99)) ? true : false;
        this.informationModel.IsCustomPrice = (Number(this.informationModel.UIUnitPrice) !== this.informationModel.UnitPrice) ? true : false;
        this.informationModel.AdjustedTotalPrice = (Number(this.informationModel.UIUnitPrice) * this.informationModel.Quantity);
        this.enableSave = (this.validQuantity && this.validUnitPrice) ? true : false;
    }

    validateUnitPrice() {
        this.enableSave = false;
        this.optionsService.optionsChanged$.next(this.isInitializing ? false : true);
        this.informationModel.WasUIChanged = this.isInitializing ? this.informationModel.WasUIChanged : true;
        this.optionsService.markOptionChangedByFacility(this.informationModel);

        this.validUnitPrice = ((Number(this.informationModel.UIUnitPrice) >= -99999.99) && (Number(this.informationModel.UIUnitPrice) <= 99999.99)) ? true : false;
        if (this.isCustomOption) {
            this.informationModel.IsCustomPrice = false;
            this.informationModel.UnitPrice = Number(this.informationModel.UIUnitPrice);
            this.informationModel.UnitPriceOverride = null;

        } else {
            this.informationModel.UnitPriceOverride = Number(this.informationModel.UIUnitPrice);
            this.informationModel.AdjustedTotalPrice = (this.informationModel.Quantity * Number(this.informationModel.UIUnitPrice));
            this.informationModel.IsCustomPrice = (Number(this.informationModel.UIUnitPrice) !== this.informationModel.UnitPrice) ? true : false;

            if ((Number(this.informationModel.UIUnitPrice) !== this.informationModel.UnitPrice)) {
                this.informationModel.IsCustomPrice = true;
            } else {
                this.informationModel.IsCustomPrice = false;
                this.informationModel.UnitPriceOverride = null;
                this.informationModel.UIUnitPrice = this.informationModel.UnitPrice;
            }
        }
        this.informationModel.IsValidUnitPrice = this.validUnitPrice;
        this.informationModel.AdjustedTotalPrice = (Number(this.informationModel.UIUnitPrice) * this.informationModel.Quantity);
        this.enableSave = (this.validQuantity && this.validUnitPrice) ? true : false;
        this.optionsService.enableSaveButton$.next(this.enableSave);
    }

    clearUnitPrice(item) {
        item.UIUnitPrice === '0.00' ? item.UIUnitPrice = null : null;
    }

    setTrailingZero(item) {
        item.UIUnitPrice = this.optionsService.setTrailingZero(item.UIUnitPrice);
    }

    closeAside() {
        this.informationModel.Quantity = (this.informationModel.Quantity === null || this.informationModel.Quantity === undefined) ? 0 : this.informationModel.Quantity;
        this.informationModel.UIUnitPrice = this.optionsService.setTrailingZero(this.informationModel.UIUnitPrice);
        this.optionsAsideService.informationAsideStatus.next(!this.enableSave);
    }

    markChanged() {
        if (this.informationModel.Note !== undefined && this.informationModel.Note !== null) {
            if (this.informationModel.Note.trim() !== '') {
                this.informationModel.WasUIChanged = true;
            } else {
                this.informationModel.Note = null;
            }
        }
        this.optionsService.optionsChanged$.next(true);
        this.optionsService.markOptionChangedByFacility(this.informationModel);
    }

    cancelEditResetValues() {
        this.enableSave = true;
        this.optionsService.enableSaveButton$.next(this.enableSave);
        this.optionsAsideService.closeInformationAside();
        this.resetClicked = false;
        this.showCancelEdit = false;
        this.browserWidthService.modalActive$.next(false);
        if (this._savedItem !== undefined) {
            this.informationModel.Note = this._savedItem.Note;
            this.informationModel.Quantity = this._savedItem.Quantity;
            this.informationModel.UnitPrice = this._savedItem.UnitPrice;
            this.informationModel.UIUnitPrice = this._savedItem.UIUnitPrice;
            this.informationModel.UnitPriceOverride = this._savedItem.UnitPriceOverride;
            this.informationModel.TotalPrice = this._savedItem.TotalPrice;
            this.informationModel.AdjustedTotalPrice = this._savedItem.AdjustedTotalPrice;
            this.informationModel.IsCustomPrice = false;
            this.informationModel.WasUIChanged = false;
            this.informationModel.IsValidUnitPrice = this._savedItem.IsValidUnitPrice;
        }
    }

    cancelEditLeaveValues() {
        this.showCancelEdit = false;
        this.browserWidthService.modalActive$.next(false);
    }

    reset(e) {
        e.preventDefault();
        this.informationModel.Note = '';
        this.informationModel.Quantity = this.informationModel.StandardOption ? this.informationModel.Quantity : 0;
        this.informationModel.CustomUnitPrice = 0.00;
        this.informationModel.UIUnitPrice = !this.isCustomOption ? this.informationModel.UnitPrice.toFixed(2) : '0.00';
        this.informationModel.UnitPriceOverride = null;
        this.informationModel.TotalPrice = Number(this.informationModel.UIUnitPrice) * this.informationModel.Quantity;
        this.informationModel.AdjustedTotalPrice = this.informationModel.TotalPrice;
        this.informationModel.IsCustomPrice = false;
        this.informationModel.WasUIChanged = true;
        this.informationModel.IsValidUnitPrice = true;
        this.validQuantity = true;
        this.validUnitPrice = true;
        this.enableSave = true;
        this.optionsService.enableSaveButton$.next(this.enableSave);
        this.informationModel.WasUIChanged = true;
        this.underMaxQuantity = !this.isCustomOption ? this.disableMaxQuantity(this.informationModel) : true;
        this.informationModel.WasUIChanged = true;
        this.optionsService.optionsChanged$.next(true);
        this.optionsService.markOptionNotChangedByFacility(this.informationModel);
    }

    /// Determines if the Quantity is valid based on the MaxQuantity
    disableMaxQuantity(item): boolean {
        if (item.MaxQuantity === 0) { return false; }
        if (item.MaxQuantity > 0 && (item.Quantity <= item.MaxQuantity)) { return false; }
        return true;
    }

    get disableQuantity() {
        let disableIncludeExclude = false;

        if (this.informationModel.IncludeExclude && this.informationModel.IncludeExclude.length > 0) {
            if (this.informationModel.Quantity === 1) { disableIncludeExclude = true; }
        }

        return ((this.informationModel.StandardOption && !this.informationModel.IsExcluded) || disableIncludeExclude);
    }

    /// Determines whether to disable the decrement quantity button
    get disableSave(): boolean {
        // [disabled]="!this.enableSave || this.informationModel.IsExcluded || this.informationModel.IsIncluded || this.underMaxQuantity || !optionForm.valid"
        if (!this.enableSave || this.underMaxQuantity) return true;
        if (this.informationModel.StandardOption && !this.informationModel.IsExcluded) return true;
        //if (this.informationModel.IsExcluded || this.informationModel.IsIncluded) return true;
        return false;
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/options-aside/options-aside.component.ts